import { Link } from "react-router-dom";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Seo } from "@/components/Seo";
import { DemoBadge } from "@/components/DemoBadge";
import { Disclaimer } from "@/components/Disclaimer";
import { ArrowRight } from "lucide-react";

export function FeatureInfo({ eyebrow, title, subtitle, points, note, ctaTo = "/register", ctaLabel = "Start Free", children }) {
  return (
    <MarketingLayout>
      <Seo title={title} description={subtitle} />
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 hero-glow" />
        <div className="relative mx-auto max-w-5xl px-4 py-16 sm:px-6">
          <div className="flex items-center gap-2">
            <span className="text-xs font-semibold uppercase tracking-widest text-accent">{eyebrow}</span>
            <DemoBadge />
          </div>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">{subtitle}</p>
          <Link to={ctaTo} className="mt-8 inline-flex items-center gap-2 rounded-xl bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25">
            {ctaLabel} <ArrowRight className="h-4 w-4" />
          </Link>

          {points && (
            <div className="mt-12 grid gap-5 sm:grid-cols-2">
              {points.map((p) => (
                <div key={p.title} className="rounded-2xl border border-border bg-card p-6">
                  <h3 className="font-display text-lg font-semibold">{p.title}</h3>
                  <p className="mt-1.5 text-sm text-muted-foreground">{p.desc}</p>
                </div>
              ))}
            </div>
          )}
          {children}
          {note && <div className="mt-10"><Disclaimer /></div>}
        </div>
      </div>
    </MarketingLayout>
  );
}
